import { prepareForPickupDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getprepareForPickupEn = () => {
  const data = prepareForPickupDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addprepareForPickup = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-can-i-prepare-for-pickups`,
    ) &&
    document.getElementById(`prepareForPickupJSONLD`) === null
  ) {
    const script = prepareForPickupJSONLDEn()
    addJSONLDToHead(script, `prepareForPickupJSONLD`)
  } else {
    removeElement(`prepareForPickupJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const prepareForPickupJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getprepareForPickupEn(),
  }
  return FaqBagsterTemplate
}
